import {forwardRef} from 'react'
import PropTypes from 'prop-types'
import {format} from 'd3-format'
import {styled} from '@mui/material/styles'
import {Paper, Stack, Typography} from '@mui/material'
import CustomTooltip from './CustomTooltip'
import useToolTipResize from '../../helpers/useToolTipResize'
import {ReactComponent as LocationIcon} from '../../../icons/map/tooltip/locationIcon.svg'
import {
  StyledBody1,
  StyledBoxTooltip,
  StyledDividerTooltip,
  StyledSpaceBox,
  StyledSubtitle1
} from '../../Dashboard/charts/PopulationDensityChart/Tooltips/Styles'

const formatCount = format('.3s')

export const TooltipRowTitle = styled('th')(({theme}) => ({
  ...theme.typography.body1,
  color: theme.palette.hpBaseDarker,
  textAlign: 'left',
  display: 'inline',
  marginBottom: theme.spacing(0.5)
}))

export const StyledTypography = styled(Typography)(({theme}) => ({
  fontSize: theme.typography.subtitle1.fontSize,
  color: theme.palette.hpBaseDarkest,
  fontWeight: theme.typography.fontWeightSemibold,
  display: 'inline',
  marginLeft: theme.spacing(0.5)
}))

export const StyledPaper = styled(Paper)(() => ({
  padding: 10,
  borderRadius: '8px',
  width: '250px'
}))

const StyledLabelSmall = styled('span')(({theme}) => ({
  ...theme.typography.labelSmall,
  fontWeight: theme.typography.fontWeightRegular,
  color: theme.palette.hpBaseDarkest
}))

const ChartSimpleTooltip = ({tooltipId, data, position, dimension, height}, ref) => {
  ChartSimpleTooltip.propTypes = {
    tooltipId: PropTypes.string,
    data: PropTypes.object,
    position: PropTypes.object,
    dimension: PropTypes.string,
    height: PropTypes.number
  }

  const {tooltipX, tooltipY} = useToolTipResize(position.x, position.y)
  return (
    <CustomTooltip id={tooltipId}>
      <div
        ref={ref}
        style={{
          visibility: data ? 'visible' : 'hidden',
          position: 'fixed',
          top: tooltipY,
          left: tooltipX,
          zIndex: 9999
        }}
      >
        {data && (
          <StyledBoxTooltip tooltipWidth='fit-content'>
            <StyledPaper elevation={1}>
              <Stack direction='column' spacing={1}>
                <Stack direction='row'>
                  <LocationIcon />
                  <StyledSubtitle1>{data.state}</StyledSubtitle1>
                </Stack>
                <StyledSpaceBox size={0} />
                <StyledDividerTooltip />
              </Stack>
              <table>
                <tbody>
                  <tr>
                    <TooltipRowTitle variant='subtitle1'>
                      {dimension}
                      {'   '}
                      <StyledTypography variant='subtitle1' color='info'>
                        {data.binNameUpdated}
                      </StyledTypography>
                    </TooltipRowTitle>
                  </tr>
                  <tr>
                    <TooltipRowTitle variant='subtitle1'>
                      Selected Adult Pop.
                      <StyledTypography variant='subtitle1' color='info'>
                        {formatCount(data.count)}
                        {'   '}
                        <StyledLabelSmall>{` (${data.percentage}% of ${
                          data.state === 'All States' ? 'US' : 'State'
                        })`}</StyledLabelSmall>
                      </StyledTypography>
                    </TooltipRowTitle>
                  </tr>
                </tbody>
              </table>
              <StyledBody1>{'*Distributions are populations within each state'}</StyledBody1>
            </StyledPaper>
          </StyledBoxTooltip>
        )}
      </div>
    </CustomTooltip>
  )
}

export default forwardRef(ChartSimpleTooltip)
